import 'globals';

(function($, window, document, PageLoadedQueue) {
    PageLoadedQueue.push(function() {
        if ($.prototype.lightGallery) {
            $('.light-gallery').lightGallery({
                download: false,
                thumbnail: true
            });
        }
    });
})(jQuery, window, document, window.PageLoadedQueue);
